import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Breadcrums from "../../common/breadcrumbs";
import { globalLoader } from "../../../../utils/commonfunction";
import { Details } from "../../services/video.services";

const ViewVideo = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { t } = useTranslation();
    const [videoData, setVideoData] = useState(null);

    const breadcrumbs = [
        { title: t("link_dashboard"), url: "/admin/dashboard" },
        { title: "Videos", url: "/admin/video/list/1" },
        { title: t("btn_view"), url: "" },
    ];

    useEffect(() => {
        if (id) {
            globalLoader(true);
            Details(id)
                .then((response) => {
                    if (response.success) {
                        setVideoData(response.data);
                    }
                    globalLoader(false);
                })
                .catch((error) => {
                    console.log("error fetching details", error);
                    globalLoader(false);
                });
        }
    }, [id]);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="animation_fade">
                <div className="card custom-card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h6 className="main-content-label">Video Details</h6>
                            <button
                                className="btn ripple btn-secondary"
                                onClick={() => navigate(-1)}
                            >
                                <i className="fa fa-arrow-left me-1"></i> Back
                            </button>
                        </div>

                        {videoData ? (
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="fw-bold">Title:</label>
                                        <p>{videoData.title || "N/A"}</p>
                                    </div>
                                    <div className="form-group">
                                        <label className="fw-bold">Status:</label>
                                        <p>
                                            {Number(videoData.status) === 1 ? (
                                                <span className="badge bg-success">Active</span>
                                            ) : (
                                                <span className="badge bg-danger">Inactive</span>
                                            )}
                                        </p>
                                    </div>
                                    <div className="form-group">
                                        <label className="fw-bold">Description:</label>
                                        <p>{videoData.description || "No description provided."}</p>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="fw-bold">Video:</label>
                                    {videoData.video_file ? (
                                        <div className="video-container">
                                            <video
                                                controls
                                                style={{
                                                    maxWidth: "400px",
                                                    maxHeight: "400px",
                                                    width: "100%",
                                                    height: "auto",
                                                    borderRadius: "8px",
                                                    border: "1px solid #dee2e6",
                                                    objectFit: "contain",
                                                    backgroundColor: "#000"
                                                }}
                                            >
                                                <source src={videoData.video_file} />
                                                Your browser does not support the video tag.
                                            </video>
                                        </div>
                                    ) : (
                                        <p className="text-muted">No video file uploaded.</p>
                                    )}

                                    <div className="mt-4">
                                        <label className="fw-bold">Thumbnail Image:</label>
                                        {videoData.thumbnail_image ? (
                                            <div className="mt-2">
                                                <img
                                                    src={videoData.thumbnail_image}
                                                    alt="Thumbnail"
                                                    style={{
                                                        maxWidth: "200px",
                                                        maxHeight: "200px",
                                                        width: "100%",
                                                        height: "auto",
                                                        borderRadius: "8px",
                                                        border: "1px solid #dee2e6",
                                                        objectFit: "cover"
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <p className="text-muted">No thumbnail uploaded.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="text-center py-5">
                                <p className="text-muted">Loading video details...</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewVideo;
